import { getDecoyBeaconState } from './decoyBeacon';
import './DecoyBeacon.css';

const DecoyBeaconControl = ({ game, onToggle }) => {
  const beacon = getDecoyBeaconState(game);
  if (!beacon.owned) return null;
  return (
    <div
      className={`coreboundDecoySetup ${beacon.deployed ? 'is-deployed' : ''}`}
    >
      <div>
        <strong>
          <span aria-hidden="true">⌖</span> Decoy Beacon{' '}
          <small>EPIC · ACTIVE</small>
        </strong>
        <span role="status">
          {beacon.used
            ? 'Used for this Core fight'
            : beacon.deployed
            ? 'Deployed · Next damaging attack hits your hologram'
            : 'Redirect one damaging attack · Once per Core fight'}
        </span>
        <span>
          Misses and full blocks keep the beacon. Siphon healing is prevented by
          the decoy.
        </span>
      </div>
      <button
        type="button"
        className="coreboundDecoyButton"
        aria-pressed={beacon.deployed}
        disabled={!beacon.canDeploy}
        onClick={onToggle}
      >
        {beacon.used
          ? 'Decoy Beacon used'
          : beacon.deployed
          ? 'Recall Decoy'
          : 'Deploy Decoy'}
      </button>
    </div>
  );
};

export default DecoyBeaconControl;
